import React, { useEffect, useState } from 'react';
import { Alert, Button, Form, Modal } from 'react-bootstrap';
import DataTable from 'react-data-table-component';
import GenereCsv from './GenereCsv';
import ColumnChooser from './ColumnChooser';
import { cleanJson } from './utils/Columns';
import { FaTimes } from 'react-icons/fa';
import { CreateContent } from './utils/PrelevementUtils';
import moment from 'moment';

const date = moment().format('YYYYMMDDHHmmss');

const Prelevement = ({ gotoAuth, annee }) => {

    const url = localStorage.getItem('url');
    const code = localStorage.getItem('code');
    // Filtrer les articles initialisés et non initialisés

    const [searchText, setSearchText] = useState('');
    const [prelevements, setPrelevements] = useState([]);
    const [dataFiltered, setDataFiltered] = useState([]);
    const [heurePrelevement, setHeurePrelevement] = useState(moment());
    const [showValide, setShowValide] = useState(false);

    const [go, setGo] = useState(false);

    const getPrelevement = () => {
        if (code && code !== '')
            fetch(`${url}GetPrele/${code}`)
                .then(response => response.json())
                .then(data => {
                    if (data === '0' || !data.data)
                        gotoAuth();
                    else {
                        // Traiter la réponse si nécessaire
                        let adh = cleanJson(data.data);
                        setPrelevements(adh);
                        setDataFiltered(adh);
                        setHeurePrelevement(moment());
                    }
                })
                .catch(error => console.error('Erreur:', error));
    };

    useEffect(() => {
        getPrelevement();
    }, [annee]);

    const validPrelevement = () => {
        //confirm('Voulez-vous valider les prélèvements ?');
        if (window.confirm('Voulez-vous valider les prélèvements ?')) {
            fetch(`${url}ValidePrele/${code}`)
                .then(response => response.json())
                .then(data => {
                    if (data === '0' || !data.data)
                        gotoAuth();
                    else {
                        // Traiter la réponse si nécessaire
                        getPrelevement();
                        alert('Prélèvements validés');
                        setShowValide(false);
                    }
                })
                .catch(error => console.error('Erreur:', error));
        }
    };

    useEffect(() => {
        getPrelevement();
    }, [annee]);


    useEffect(() => {
        setDataFiltered(prelevements);
    }, [prelevements]);


    const filtre = (value, data) => {
        setSearchText(value);
        if (value.length < 1) {
            setDataFiltered(data);
        } else {
            const filtered = data.filter(item => {
                // must contains all word of value
                return value.split(' ').every(word => {
                    return JSON.stringify(item).toLowerCase().includes(word.toLowerCase());
                });
            });
            setDataFiltered(filtered);
            // console.log(filtered);
        }
    }

    const handleChangesearchText = (e) => {
        filtre(e.target.value, prelevements);
    };

    const [columnsSel, setColumnsSel] = useState(['rum', 'entreprise', 'libelle', 'montant', 'block']);
    // const [columns, setColumns] = useState([]);

    const [columns, setColumns] = useState([]);

    const handleGenereXml = () => {
        let content = CreateContent(prelevements);
        console.log(content);
        download(`prelevements_${date}.xml`, content);
        setGo(true);

        setShowValide(true);
    }

    // fonction pour générer le fichier xml a partir d'un string
    const download = (filename, text) => {
        var element = document.createElement('a');
        element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
        element.setAttribute('download', filename);
        element.style.display = 'none';
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
    }

    // nombre de minutes entre heure de prélevement et maintenant en utilisant moment
    const diff = moment().diff(heurePrelevement, 'minutes');

    return (
        <div>
            <GenereCsv data={prelevements} fichier="Prelevement" visible={false} go={go} setGo={setGo} />

            <div className="d-grid gap-2">
                <Button variant="primary" onClick={handleGenereXml}>Générer les fichiers (XML et CSV)</Button>
            </div>

            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', width: '100%' }}>

                <h1 style={{ marginLeft: '10px' }}>Prélèvements</h1>
                <div style={{ flexGrow: 1 }} />
                <ColumnChooser columnsName={columnsSel} data={dataFiltered} setColumns={setColumns} />
            </div>

            <DataTable
                columns={columns}
                data={dataFiltered}
                pagination={true}
                paginationPerPage={10}
                paginationRowsPerPageOptions={[10, 20, 30, 50, 100]}
                highlightOnHover
                subHeader
                subHeaderComponent={(
                    // <div style={{ display: 'flex', alignItems: 'center' }}>

                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', width: '100%' }}>

                        <input
                            type="text"
                            value={searchText}
                            onChange={handleChangesearchText}
                            // onChange={(e) => setSearchText(e.target.value)}
                            placeholder="Rechercher..."
                        />
                        {searchText && <FaTimes className='h-5' onClick={() => filtre('', prelevements)} />}
                        <div style={{ flexGrow: 1 }} />
                    </div>
                )}
                defaultSortField="id"
                defaultSortAsc={false}
                subHeaderAlign="left"
                noHeader={true}
                paginationComponentOptions={{
                    rowsPerPageText: 'Lignes par page:',
                }}
            />
            <Modal size="xl" show={showValide} onHide={() => setShowValide(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Valider le fichier de prélèvements</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="text-center">
                        <h4>Si vous avez créer des dossiers avec des prélèvement depuis {moment().diff(heurePrelevement, 'minutes')} minutes<br />Recharger la page (F5)</h4>
                        <hr />
                        <p>Sinon vous pouvez valider les prélèvements</p>
                        <div className="d-grid gap-2">
                            <Button variant="primary" onClick={validPrelevement}>Valider</Button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </div>


    );
}

export default Prelevement;
